import React from 'react';

import ContactsPage from '../components/ContactsPage';

const ContactsApp = (props) => (
  <ContactsPage {...props} />
);

export default ContactsApp;
